<template>
<div class="col-xxl-8 col-lg-12 box-col-12">
    <div class="card">
        <div class="card-header card-no-border">
            <h5>Desempeño General</h5>
        </div>
        <div class="card-body pt-0">
            <div class="row m-0 overall-card">
                <div class="col-xl-12 col-md-12 col-sm-7 p-0">
                    <div class="chart-right">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card-body p-0">
                                    <ul class="balance-data">
                                        <li>
                                            <span class="circle bg-warning"> </span><span class="f-light ms-1">Realizadas</span>
                                        </li>
                                        <li>
                                            <span class="circle bg-primary"> </span><span class="f-light ms-1">Pendientes</span>
                                        </li>
                                    </ul>
                                    <div class="current-sale-container">
                                        <apexchart height="305" type="bar" :options="apexDashboard.options3" :series="apexDashboard.series3"></apexchart>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    overallbalance
} from "../../../data/dashboard/default"
import {
    apexDashboard
} from "../../../data/comon";
export default {
    components: {
    },
    data() {
        return {
            apexDashboard: apexDashboard,
            overallbalance: overallbalance
        };
    },
}
</script>
